<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 21.4706V13.4706C15 13.2054 14.8946 12.951 14.7071 12.7635C14.5196 12.5759 14.2652 12.4706 14 12.4706H10C9.73478 12.4706 9.48043 12.5759 9.29289 12.7635C9.10536 12.951 9 13.2054 9 13.4706V21.4706" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 10.4705C2.99993 10.1796 3.06333 9.89217 3.18579 9.62827C3.30824 9.36436 3.4868 9.13035 3.709 8.94255L10.709 2.94355C11.07 2.63846 11.5274 2.47107 12 2.47107C12.4726 2.47107 12.93 2.63846 13.291 2.94355L20.291 8.94255C20.5132 9.13035 20.6918 9.36436 20.8142 9.62827C20.9367 9.89217 21.0001 10.1796 21 10.4705V19.4705C21 20.001 20.7893 20.5097 20.4142 20.8848C20.0391 21.2598 19.5304 21.4705 19 21.4705H5C4.46957 21.4705 3.96086 21.2598 3.58579 20.8848C3.21071 20.5097 3 20.001 3 19.4705V10.4705Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#78829D',
      required: false,
    },
  },
};
</script>
